import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {TestRackService} from "app/modules/models/test-rack/services/test-rack.service";
import {extractDataFromModel, extractDataFromProperty} from "@catcore/utils";
import {NotificationsService, ProjectService} from "@catcore/services";
import {TestRackSetupService} from "@catmodules/models/test-rack/services/test-rack-setup.service";
import {ConfirmationService} from "primeng/components/common/confirmationservice";
import {BreadcrumbService} from "@catmodules/widgets/breadcrumb/services/breadcrumb.service";

@Component({
  selector: 'catapp-test-rack-setup',
  templateUrl: './test-rack-setup.component.html',
  styleUrls: ['./test-rack-setup.component.scss']
})
export class TestRackSetupComponent implements OnInit {

  form: FormGroup;
  subscription = null;
  projectSubscription = null;
  testRackSetup = null;

  project = null;
  testRackOptions = [];
  guiZones = [];

  labels = {
    testRackPlaceholder: 'Test Rack',
    testRack: 'Test Rack',
  };

  constructor(private testRackService: TestRackService,
              private projectService: ProjectService,
              private testRackSetupService: TestRackSetupService,
              private notificationService: NotificationsService,
              private confirmationService: ConfirmationService,
              private breadcrumbService: BreadcrumbService) {
    this.form = new FormGroup({
      testRack: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit() {
    this.subscription = this.testRackService
      .getAll()
      .subscribe((testRacks: any) => {
        const itemList = [];
        testRacks.forEach((item) => {
          itemList.push({label: item.name, value: item});
        });

        this.testRackOptions = itemList;
      }
    );

    this.projectSubscription = this.projectService.getCurrentProject().subscribe((project) => {
      this.project = project;
      if (this.project !== null && this.project.id !== null) {
        const subscr = this.projectService.getTestRackSetups(this.project)
          .finally(() => {subscr.unsubscribe()})
          .subscribe((testRackSetups: any) => {
          if (testRackSetups.length > 0) {
            this.testRackSetup = testRackSetups[0];
            this.updateTestRackFormValue(this.testRackSetup);
          }
        });
      }
    });

    this.breadcrumbService.update([{label: 'Setup', value: 'testRackSetup' }]);
  }

  updateTestRackFormValue(testRackSetup) {
    if (testRackSetup === null) {
      this.form.patchValue({testRack: null});
    } else {
      const testRackLink = testRackSetup._links.test_rack.href;
      const option = this.testRackOptions.find((option) => {
        return option.value._links.self.href === testRackLink
      });
      if (option) {
        console.log('patching form value', option);
        this.form.patchValue({testRack: option.value});
      }
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.projectSubscription.unsubscribe();
  }

  onSubmit($event) {
    if (this.project !== null) {
      if (this.testRackSetup !== null) {
        this.testRackSetupService.update({
          id: this.testRackSetup.id
        })
      } else {
        this.testRackSetupService.add({
          test_rack: this.form.value.testRack._links.self.href,
          project: this.project._links.self.href
        }).subscribe((result) => {
          this.testRackSetup = result;
          this.notificationService.success('Added test rack setup', 'The test rack setup has been added successfully.');
        });
      }
    }
  }

  onDelete($event) {
    if (this.testRackSetup !== null) {
      this.confirmationService.confirm({
        message: 'Do you really want to remove the test rack setup?',
        accept: () => {
          const subsc = this.testRackSetupService
            .delete(this.testRackSetup)
            .finally(() => {
              subsc.unsubscribe()
            })
            .subscribe((result) => {
              this.notificationService.success('Removed test rack setup', 'The test rack setup has been removed successfully.');
              this.testRackSetup = null;
              this.updateTestRackFormValue(null);
            });
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/test-rack/components/test-rack-setup/test-rack-setup.component.ts